import { ThemeColor } from '@/enums'
import { InputWithAddon } from '../InputWithAddon'
import { NumberInputBase } from '../NumberInputBase'
import { Typography } from '../Typography'

export interface UnitInputProps
  extends React.ComponentProps<typeof InputWithAddon> {
  unit: string
}

export const UnitInput = ({ unit, ...props }: UnitInputProps) => (
  <InputWithAddon
    addonAfter={
      <Typography color={ThemeColor.b50} variant="p1Body">
        {unit}
      </Typography>
    }
    inputComponent={NumberInputBase}
    {...props}
  />
)
